import React, { FC, useState } from "react";
import { StarIcon as StarIconSolid } from "@heroicons/react/24/solid";
import { StarIcon as StarIconOutline } from "@heroicons/react/24/outline";

export interface BtnLikeIconProps {
  className?: string;
  colorClass?: string;
  isFeatured?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const ButtonFeaturedIcon: FC<BtnLikeIconProps> = ({
  className = "",
  colorClass = "text-white bg-black bg-opacity-30 hover:bg-opacity-50",
  isFeatured = false,
  onClick
}) => {
  const [likedState, setLikedState] = useState(isFeatured);

  React.useEffect(() => {
    setLikedState(isFeatured);
  }, [isFeatured]);

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (onClick) return onClick(e);
    setLikedState(!likedState);
  };

  return (
    <div
      className={`nc-BtnLikeIcon w-8 h-8 flex items-center justify-center rounded-full cursor-pointer ${
        likedState ? "nc-BtnLikeIcon--liked" : ""
      }  ${colorClass} ${className}`}
      data-nc-id="BtnLikeIcon"
      title="featured"
      onClick={handleClick}
    >
      {likedState ? <StarIconSolid className={"size-5"}/> : <StarIconOutline className={"size-5"}/>}
    </div>
  );
};

export default ButtonFeaturedIcon;
